module.exports = __webpack_public_path__ + "static/logo_full3-c2bca02e0608239a72181da7b72a4e28.png";